import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AlertsReportPage, type ReportPeriod } from '../../../../features/B5/alerts-report';

const Search = z.object({
  period: z.enum(['day', 'week', 'month']).optional().catch(undefined),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional().catch(undefined),
});

/** D-95: "דוח התראות" — alerts by day / week / month, by type and by branch (parent accounts); PDF via print. */
export const Route = createFileRoute('/_app/client/$clientId/report')({
  validateSearch: (s) => Search.parse(s),
  component: ReportTab,
});

function ReportTab() {
  const { clientId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AlertsReportPage
      clientId={clientId}
      period={(search.period as ReportPeriod | undefined) ?? 'week'}
      date={search.date}
      setSearch={(p) => void navigate({ search: (prev) => ({ ...prev, ...p }), replace: true })}
    />
  );
}
